import {Component, ComponentRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {first, tap} from 'rxjs/operators';
import {DynamicComponentBaseComponent} from './components/dynamic-component-base/dynamic-component-base.component';
import {DynamicDirective} from './directives/dynamic/dynamic.directive';
import {DynamicComponentObject} from './interfaces/dynamic-component-object';
import {DynamicService} from './services/dynamic/dynamic.service';

@Component({
    selector: 'dynamic-component',
    templateUrl: './dynamic.component.html',
    standalone: false
})
export class DynamicComponent {
  @ViewChild(DynamicDirective, {static: true}) dynamic!: DynamicDirective;
  @Output() CreatedComponent: EventEmitter<ComponentRef<DynamicComponentBaseComponent>> =
    new EventEmitter();

  private _component!: DynamicComponentObject<Record<string, unknown>>;
  @Input() set component(val: DynamicComponentObject<Record<string, unknown>>) {
    if (val) {
      const res = this.dynamicService.dynamicComponentCreator(val, this.dynamic);
      res
        .pipe(
          first(),
          tap((el) => {
            this.CreatedComponent.emit(el);
          }),
        )
        .subscribe();
    }
  }
  get component(): DynamicComponentObject<Record<string, unknown>> {
    return this._component;
  }

  constructor(private dynamicService: DynamicService) {}
}
